import { oroMxProfileAssets, oroMxProfileAvatars } from '@/shared/theme/oro-mx-page-data';
import { isPresetAvatarId, presetAvatarIds } from '@/shared/theme/preset-avatars';

const HEAD_FILE = /head-([2-8])(?:\.png)?(?:\?.*)?$/i;

function avatarByHeadIndex(index: number): string {
  return oroMxProfileAvatars[index] ?? oroMxProfileAvatars[0] ?? oroMxProfileAssets.avatar;
}

/** 把入库的 preset id / 本地 head 路径 / 外链解析成 Oro MX 圆形头像地址。 */
export function resolveOroMxAvatarSrc(avatarUrl?: string | null): string {
  const value = avatarUrl?.trim();
  if (!value) {
    return oroMxProfileAssets.avatar;
  }

  const exact = oroMxProfileAvatars.find((src) => src === value);
  if (exact) {
    return exact;
  }

  const head = value.match(HEAD_FILE);
  if (head) {
    const mapped = oroMxProfileAvatars.find((src) => src.includes(`head-${head[1]}`));
    if (mapped) {
      return mapped;
    }
  }

  if (isPresetAvatarId(value)) {
    return avatarByHeadIndex(presetAvatarIds.indexOf(value));
  }

  if (/^https?:\/\//i.test(value) || value.startsWith('/') || value.startsWith('data:')) {
    return value;
  }

  return oroMxProfileAssets.avatar;
}

/** 编辑页只能选 7 张本地默认头；无法映射时回退第一张。 */
export function resolveOroMxEditableAvatar(avatarUrl?: string | null): string {
  const resolved = resolveOroMxAvatarSrc(avatarUrl);
  return oroMxProfileAvatars.includes(resolved)
    ? resolved
    : (oroMxProfileAvatars[0] ?? oroMxProfileAssets.avatar);
}

/** 本地 head 图映射到后端白名单 preset id，避免改服务端头像契约。 */
export function oroMxAvatarToPresetId(src: string): string {
  const resolved = resolveOroMxEditableAvatar(src);
  const index = oroMxProfileAvatars.indexOf(resolved);
  return presetAvatarIds[index] ?? presetAvatarIds[0] ?? 'trophy';
}
